import { CSS_CLASSES } from './constants';

interface PlaceholderImageProps {
  src: string;
}

export const PlaceholderImage = ({ src }: PlaceholderImageProps) => (
  <img
    src={src}
    alt=""
    className={CSS_CLASSES.placeholder}
    aria-hidden="true"
  />
);

interface MainImageProps {
  src: string;
  srcSet: string;
  alt: string;
  priority: boolean;
  imgRef: React.RefObject<HTMLImageElement>;
  onLoad: () => void;
  onError: () => void;
}

export const MainImage = ({
  src,
  srcSet,
  alt,
  priority,
  imgRef,
  onLoad,
  onError,
}: MainImageProps) => (
  <img
    ref={imgRef}
    src={src}
    srcSet={srcSet}
    sizes="100vw"
    alt={alt}
    aria-hidden="true"
    className={CSS_CLASSES.mainImage}
    loading={priority ? 'eager' : 'lazy'}
    onLoad={onLoad}
    onError={onError}
  />
);
